[
    {
        "display": "false",
        "ui_columnname": "Action",
        "db_columnname": "rsmsStatus",
        "datatype": "char",
        "mappingkey": "rsmsStatus",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Comment ID",
        "db_columnname": "commentId",
        "datatype": "String",
        "mappingkey": "commentId",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Group",
        "db_columnname": "groupName",
        "datatype": "String",
        "mappingkey": "groupName",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Report Date",
        "db_columnname": "reportDate",
        "datatype": "date",
        "mappingkey": "reportDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Path",
        "db_columnname": "fieldPath",
        "datatype": "String",
        "mappingkey": "fieldPath",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Field Name",
        "db_columnname": "fieldName",
        "datatype": "String",
        "mappingkey": "fieldName",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Field Value",
        "db_columnname": "fieldValue",
        "datatype": "String",
        "mappingkey": "fieldValue",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Event Type",
        "db_columnname": "eventType",
        "datatype": "String",
        "mappingkey": "eventType",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Asset Class",
        "db_columnname": "assetClass",
        "datatype": "String",
        "mappingkey": "assetClass",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Average Type",
        "db_columnname": "avgType",
        "datatype": "String",
        "mappingkey": "avgType",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Comment",
        "db_columnname": "comment",
        "datatype": "String",
        "mappingkey": "comment",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Variance",
        "db_columnname": "dailyVariance",
        "datatype": "String",
        "mappingkey": "dailyVariance",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Active",
        "db_columnname": "isActive",
        "datatype": "String",
        "mappingkey": "isActive",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Create Date",
        "db_columnname": "createdDate",
        "datatype": "String",
        "mappingkey": "createdDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Created By",
        "db_columnname": "createdBy",
        "datatype": "String",
        "mappingkey": "createdBy",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Update Date",
        "db_columnname": "updatedDate",
        "datatype": "String",
        "mappingkey": "updatedDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Updated By",
        "db_columnname": "updatedBy",
        "datatype": "String",
        "mappingkey": "updatedBy",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    }
]